/**
 * @author NikolaV
 */
import { Ajax2 } from '@shared/Ajax';
import * as React from 'react';


function get(uuid: string): Promise<IProject> {
    return Ajax2({
        url: kuura.getContextPath() + '/api/1/project/' + uuid,
    }).then(r => r.project);
}

export const ProjectService = {
    get
};
